<div class="login-container">
  <!-- Background: gestito globalmente in src/theme/manufacturer.scss.
       Non toccare — coerenza con altre pagine (manufacturer, history-order,
       check-order-manufacturer, ecc.) -->
  <div class="custom-login background-image"></div>

  <!-- Card floating al centro con form login -->
  <div class="form-wrapper">
    <div class="login-card">
      <!-- Logo circolare overlappato in cima alla card -->
      <div class="login-card__logo">
        <img src="assets/icons/logo-diakonix-black.png" alt="Diakonix" />
      </div>

      <header class="login-card__header">
        <h1 class="login-card__title">Login</h1>
        <p class="login-card__subtitle">
          Effettua il login per poter utilizzare Diakonix
        </p>
      </header>

      @if (invalidLogin) {
        <div class="login-card__alert" role="alert">
          Errore in fase di registrazione
        </div>
      }

      <form
        class="login-form"
        [formGroup]="loginForm"
        (ngSubmit)="login(loginForm.value)"
        autocomplete="on"
        novalidate
      >
        <!-- Email -->
        <div class="login-form__field">
          <label for="login-email" class="login-form__label">Email</label>
          <input
            id="login-email"
            type="email"
            class="login-form__input"
            formControlName="email"
            placeholder="nome@azienda.it"
            autocomplete="username"
            required
          />
          @if (
            (loginForm.get('email')?.touched || loginForm.get('email')?.dirty) &&
            loginForm.get('email')?.errors
          ) {
            <div class="login-form__error">Email mancante o non valida</div>
          }
        </div>

        <!-- Password + toggle mostra/nascondi -->
        <div class="login-form__field">
          <label for="login-password" class="login-form__label">Password</label>
          <div class="login-form__password-wrap">
            <input
              id="login-password"
              [type]="passwordVisible ? 'text' : 'password'"
              class="login-form__input login-form__input--with-icon"
              formControlName="password"
              placeholder="La tua password"
              autocomplete="current-password"
              required
            />
            <button
              type="button"
              class="login-form__password-toggle"
              (click)="toggleVisibility()"
              [attr.aria-label]="passwordVisible ? 'Nascondi password' : 'Mostra password'"
            >
              <img
                [src]="passwordVisible ? 'assets/icons/eye-slash-fill.svg' : 'assets/icons/eye.svg'"
                alt=""
                width="18"
                height="18"
              />
            </button>
          </div>
          @if (
            (loginForm.get('password')?.touched || loginForm.get('password')?.dirty) &&
            loginForm.get('password')?.errors
          ) {
            <div class="login-form__error">Password obbligatoria</div>
          }
        </div>

        <button
          type="submit"
          class="login-form__submit"
          [disabled]="loginForm.invalid"
        >
          Accedi
        </button>

        <a routerLink="/reset-password" class="login-form__link">
          Password dimenticata?
        </a>
      </form>

      <footer class="login-card__footer">
        © {{ currentYear }} · Connecta
      </footer>
    </div>
  </div>
</div>
